import React from "react";
import "./ProductDetail3.css";
import { Link } from "react-router-dom";
import Gfooter from "../Component/Gfooter";

function ProductDetail3() {
  return (
    <div className="ifile-detail">

      {/* HERO SECTION */}
      <div className="ifile-hero">
        <img src="product-img/ifilemanagement.jpg" alt="iFile" />

        <div className="ifile-overlay">
          <h1 data-aos="fade-up">Global iFile Management System</h1>
          <p data-aos="fade-up" data-aos-delay="100">
            Smart Document Management for Modern Businesses 📁
          </p>

          <div className="breadcrumb">
            <span>Home</span> ➝ <span>Products</span> ➝ <b>iFile</b>
          </div>
        </div>
      </div>

      {/* INTRO */}
      <div className="container ifile-intro">
        <div className="row align-items-center">

          <div className="col-lg-6" data-aos="fade-right">
            <img
              src="product-img/efile.jpg"
              alt="document system"
              className="img-fluid intro-img"
            />
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <h2>Streamlining Document Management</h2>
            <p>
              Global iFile Management System is a powerful document management
              solution that helps organizations digitize, store, and manage
              documents efficiently.
            </p>
            <p>
              It improves workflow, enhances collaboration, and ensures data
              security with advanced document handling features.
            </p>

            <Link to="/contact-us">
              <button className="demo-btn">Request Demo</button>
            </Link>
          </div>

        </div>
      </div>

      {/* FEATURES */}
      <div className="ifile-features">
        <div className="container">
          <h2 className="section-title" data-aos="zoom-in">
            Key Features
          </h2>

          <div className="row">

            <div className="col-md-6 feature-box" data-aos="fade-up">
              <h4>Document Capture & Storage</h4>
              <p>
                Securely capture and store documents in a centralized digital
                system.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="100">
              <h4>Smart Search & Retrieval</h4>
              <p>
                Quickly find documents using advanced indexing and search
                functionality.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="200">
              <h4>Version Control</h4>
              <p>
                Maintain document history and track changes with version
                management.
              </p>
            </div>

            <div className="col-md-6 feature-box" data-aos="fade-up" data-aos-delay="300">
              <h4>Security & Compliance</h4>
              <p>
                Protect sensitive data with role-based access and encryption.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* BENEFITS */}
      <div className="ifile-benefits">
        <div className="container">
          <h2 className="section-title" data-aos="zoom-in">
            Benefits
          </h2>

          <div className="row">

            <div className="col-md-6 benefit-card" data-aos="flip-left">
              <h4>Improved Productivity</h4>
              <p>
                Reduce time spent on document handling and focus on core tasks.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-right">
              <h4>Better Collaboration</h4>
              <p>
                Teams can access and work on documents from anywhere.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-left">
              <h4>Cost Savings</h4>
              <p>
                Reduce paper usage and storage costs with digital solutions.
              </p>
            </div>

            <div className="col-md-6 benefit-card" data-aos="flip-right">
              <h4>Data Security</h4>
              <p>
                Ensure confidentiality with secure document access control.
              </p>
            </div>

          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="ifile-cta">
        <h2 data-aos="zoom-in">Go Paperless Today</h2>
        <p data-aos="fade-up">
          Upgrade your document management with smart automation.
        </p>

        <Link to="/contact-us">
          <button className="cta-btn">Get Started</button>
        </Link>
      </div>

      <Gfooter />
    </div>
  );
}

export default ProductDetail3;